import { Component, OnInit,Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material'
import { ImageSliderComponent } from '../image-slider/image-slider.component';

@Component({
  selector: 'app-home-details-dialog',
  templateUrl: './home-details-dialog.component.html',
  styleUrls: ['./home-details-dialog.component.scss']
})
export class HomeDetailsDialogComponent implements OnInit {

  home_data: any
	home_price: String
	owner_phone: String

  constructor(
		public dialog: MatDialog,
    private matDialogRef: MatDialogRef<HomeDetailsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.home_data = data;
    console.log("home_Data:"+this.home_data);
		this.home_price =
			'$' +
			this.home_data.ownerPrice.toLocaleString(undefined, {
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			})
		this.owner_phone = this.data.phone.replace(
			/(\d\d\d\d\d)(\d\d\d)(\d\d)(\d\d)/,
			'($1) $2-$3-$4'
		)
		console.log(this.owner_phone)
		console.log("data home details"+data)
   }

  ngOnInit() {
  }
  closeDetails() {
		this.matDialogRef.close()
	}
	showSlider(image_id: String) {
		console.log("img_id"+image_id);
		console.log("home_data"+this.home_data.buildingPhotos);
    this.dialog.open(ImageSliderComponent, {
      data: { images: this.home_data.buildingPhotos, current_image: image_id },
      panelClass: 'image-slider-dialog',
      backdropClass: 'image-slider-backdrop',
      autoFocus: false,
    });
  }
}
